import { render, staticRenderFns } from "./CoralsolDafor.vue?vue&type=template&id=07b2afb6&"
import script from "./CoralsolDafor.vue?vue&type=script&lang=js&"
export * from "./CoralsolDafor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports